import React, { useEffect, useState } from "react";
import { DropDown, ToggleSwitch } from "../../commons";
import DatePicker from "react-datepicker";
import "./style.scss";
import { analyticsGrey, analyticsIcon } from "../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CalenderIcon, Excel, RreshIcon } from "../../Icon";
import {
  GstrTwoADataType,
  GstrTwoBInvoiceData,
} from "../../../commonTypes/gstTypes";
import { OptionsType } from "../../../commonTypes/universalTypes";
import { Alert, Chip, InputAdornment, TextField } from "@mui/material";

const SELECT_DATA_TYPES = [
  {
    value: "all",
    label: "ALL",
  },
  {
    value: "b2b",
    label: "B2B",
  },
  {
    value: "b2ba",
    label: "B2BA",
  },
  {
    value: "cdn",
    label: "CDN",
  },
  {
    value: "cdna",
    label: "CDNA",
  },
  {
    value: "tcs",
    label: "TCS",
  },
  {
    value: "tds",
    label: "TDS",
  },
  {
    value: "impg",
    label: "IMPG",
  },
  {
    value: "impgsez",
    label: "IMPGSEZ",
  },
];
type AppProps = {
  gstDetails: any;
  option: any;
  setGstDetails: any;
  handleApply: () => void;
  handleRefreshApply: () => void;
  setSelectedYear: any;

  selectedYear: any;
  setSelectedMonths: any;
  selectedMonths: any;
  activeStatus: string;
  type: string;
  fetching: boolean;
  isReportsDownloadPresent?: boolean;
  isShowMissingInvoices?: boolean;
  activeStatusValue: string;
  setActiveStatus: React.Dispatch<React.SetStateAction<string>>;
  setClearFilter: (data: boolean) => void;
  handlePrepareDownloadReportData?: () => void;
  // selectedDate: Date;
  gstrTwoBReturnsData?: any;
  // setSelectedDate: React.Dispatch<React.SetStateAction<Date>>;
  setSelectDataType?: React.Dispatch<React.SetStateAction<OptionsType>>;
  selectDataType?: OptionsType;
  setActiveStatusValue: React.Dispatch<React.SetStateAction<string>>;
  data?: GstrTwoADataType | {};
  setShowMissingInvoices: React.Dispatch<React.SetStateAction<boolean>>;
  showMissingInvoices: boolean;
};

const GstrTwoATwoBHeader = ({
  gstDetails,
  option,
  type,
  setGstDetails,
  handleApply,
  fetching,
  data,
  activeStatus,
  activeStatusValue,
  setActiveStatus,
  setClearFilter,
  setActiveStatusValue,
  // selectedDate,
  // setSelectedDate,
  gstrTwoBReturnsData,
  handlePrepareDownloadReportData,
  isReportsDownloadPresent,
  selectDataType,
  setSelectDataType,
  setSelectedYear,
  selectedYear,
  setSelectedMonths,
  selectedMonths,
  handleRefreshApply,
  setShowMissingInvoices,
  showMissingInvoices,
  isShowMissingInvoices
}: AppProps) => {
  const [isSummaryVisible, setIsSummaryVisible] = useState(true);
  const [isDownloadVisible, setIsDownloadVisible] = useState(false);

  useEffect(() => {
    setShowMissingInvoices(false);
  }, [selectDataType]);

  useEffect(() => {
    if (selectedMonths?.length) {
      handleApply();
      setIsDownloadVisible(true);
    }
  }, [selectedMonths, selectDataType, gstDetails, showMissingInvoices]);

  const convertToMonth = (monthNumber: number) => {
    const month = new Date(`${monthNumber}-01-01`).toLocaleString("default", {
      month: "long",
    });
    return month;
  };

  const [error, setError] = useState("");

  const handleMonthChange = (date: any) => {
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "long" });

    if (!selectedYear) {
      setSelectedYear(year);
    }

    if (selectedYear && year !== selectedYear) {
      setError(`You can only select months from the year ${selectedYear}.`);
      return;
    }

    if (selectedMonths.length >= 3) {
      setError("You can only select up to 3 months.");
      return;
    }

    const formattedMonth = `${month} ${year}`;
    if (!selectedMonths.includes(formattedMonth)) {
      setSelectedMonths([...selectedMonths, formattedMonth]);
    }

    setError(""); // Clear error if any
  };

  const removeMonth = (month: any) => {
    setSelectedMonths(selectedMonths.filter((m: string) => m !== month));
    if (selectedMonths.length === 1) {
      setSelectedYear(null); // Allow year change if no months are selected
    }
  };

  const handleToggle = () => {
    setShowMissingInvoices(!showMissingInvoices);
  };
  return (
    <div>
      <div>
        <div className="row pl-4 d-flex align-items-center">
          <div className="form-group mt-4 col-md-3">
            <div>
              <label className="mb-1" htmlFor="BYPRODUCT">
                GSTIN
              </label>
              <DropDown
                extraClasses={`react-select`}
                disabled={fetching}
                placeholder="Choose Gst Number..."
                options={
                  option
                    ? [{ label: "Select...", value: undefined }, ...option]
                    : []
                }
                handleChange={(e: any) => setGstDetails(e)}
                value={gstDetails}
              />
            </div>
          </div>
          <div className="form-group mt-4 col-md-3">
            <label className="mb-1" htmlFor="BYPRODUCT">
              Period
            </label>
            <div className="custom-datepicker">
              <DatePicker
                selected={null}
                onChange={handleMonthChange}
                showMonthYearPicker
                minDate={selectedYear ? new Date(selectedYear, 0, 1) : null}
                maxDate={selectedYear ? new Date(selectedYear, 11, 31) : null}
                dateFormat="MM/yyyy"
                className="form-control"
                disabled={!gstDetails?.value || fetching}
                customInput={
                  <TextField
                    fullWidth
                    disabled={!gstDetails?.value || fetching}
                    InputProps={{
                      startAdornment: (
                        <div style={{ padding: "10px", position: "static" }}>
                          {selectedMonths.map(
                            (month: string, index: number) => (
                              <Chip
                                key={index}
                                label={month}
                                onDelete={() => {
                                  if (!fetching) removeMonth(month);
                                }}
                                size="small"
                                sx={{ mt: 0.8 }}
                              />
                            )
                          )}
                        </div>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          style={{
                            cursor:
                              selectedMonths?.length < 3 && gstDetails?.value
                                ? "pointer"
                                : "not-allowed",
                          }}
                        >
                          <CalenderIcon />
                        </InputAdornment>
                      ),
                    }}
                    inputProps={{
                      style: {
                        color:
                          gstDetails?.value && !fetching
                            ? "rgba(0, 0, 0, 0.87)"
                            : "rgba(0, 0, 0, 0.38)",
                        backgroundColor:
                          gstDetails?.value && !fetching ? "#fff" : "#f5f5f5",
                        cursor:
                          gstDetails?.value && !fetching
                            ? "text"
                            : "not-allowed",
                        padding: "0.375rem 0.75rem",
                      },
                    }}
                    sx={{
                      "& .MuiInputBase-root.Mui-disabled": {
                        backgroundColor: "#f5f5f5",
                      },
                      "& .MuiInputAdornment-root": {
                        pointerEvents: gstDetails?.value ? "auto" : "none",
                      },

                      height: "auto",
                    }}
                  />
                }
              />
            </div>
          </div>
          {selectDataType ? (
            <div className="form-group mt-4 col-md-2">
              <div>
                <label className="mb-1" htmlFor="BYPRODUCT">
                  Data Type
                </label>
                <DropDown
                  extraClasses={`react-select`}
                  options={SELECT_DATA_TYPES}
                  handleChange={(e: any) =>
                    setSelectDataType && setSelectDataType(e)
                  }
                  disabled={fetching}
                  value={selectDataType}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="mt-4">
            <button
              className="btn btn-outline mt-2"
              onClick={handleRefreshApply}
              disabled={
                !gstDetails?.value ||
                !selectedYear ||
                fetching ||
                showMissingInvoices
              }
            >
              <RreshIcon />
              <span className="mr-1"></span>
              Refresh
            </button>
          </div>

          {/* commented for future use  */}
          {/* {type === "GstrTwoB" ? (
            <div className="ml-2" style={{ marginTop: "52px" }}>
              <div
                onClick={() => setIsSummaryVisible(!isSummaryVisible)}
                className="flex-center show-hide-btn-head"
              >
                {
                  <div
                    className="show-hide-btn"
                    style={
                      isSummaryVisible
                        ? {
                            border: "1px solid #dd4433",
                            backgroundColor: "#fff6f5",
                          }
                        : { border: "1px solid #262a44" }
                    }
                  >
                    <img
                      src={isSummaryVisible ? analyticsIcon : analyticsGrey}
                      alt=""
                    />
                    <div
                      style={
                        isSummaryVisible
                          ? { color: "#dd4433" }
                          : { color: "#262a44" }
                      }
                    >
                      {isSummaryVisible ? "Hide GST Info" : "Open GST Info"}
                    </div>
                  </div>
                }
              </div>
            </div>
          ) : null} */}
          {/* commented for future use  */}
          {/* <div className="col-md-5"></div>
          <div className="form-group mt-5 col-md-1">
          <Gstr2aFilter
            activeStatus={activeStatus}
            activeStatusValue={activeStatusValue}
            setActiveStatus={setActiveStatus}
            setClearFilter={setClearFilter}
            setActiveStatusValue={setActiveStatusValue}
          />
        </div> */}
          {!!data && data && isReportsDownloadPresent ? (
            <div
              className={`d-flex  pr-4 mt-3 ml-3`}
              style={{ justifyContent: "start" }}
            >
              {isReportsDownloadPresent && (
                <div className="pointer">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-download-invoice">
                        Download Reports
                      </Tooltip>
                    }
                  >
                    <button
                      style={{ border: "none", marginTop: "-12px" }}
                      onClick={handlePrepareDownloadReportData}
                      disabled={
                        // !selectedDate
                        !gstDetails?.value || fetching || showMissingInvoices
                      }
                      className="pointer mt-3"
                    >
                      <Excel />
                    </button>
                  </OverlayTrigger>
                </div>
              )}
            </div>
          ) : null}
         { isShowMissingInvoices?<div>
            <label
              className="mb-1 mt-2"
              htmlFor="Stage"
              style={{ fontSize: "14px" }}
            >
              Show Missing Invoices
            </label>
            <div>
              <ToggleSwitch
                handleToggleChange={handleToggle}
                isChecked={showMissingInvoices}
                disabled={
                  !gstDetails?.value ||
                  fetching ||
                  (selectDataType && selectDataType?.value !== "all") ||
                  selectedYear == null
                }
              />
            </div>
          </div>:""}
        </div>
      </div>

      {type === "GstrTwoB" &&
      isSummaryVisible &&
      gstrTwoBReturnsData?.gst_number ? (
        <div className="gstr_two_b_summary">
          <div className="d-flex">
            <div style={{ flexGrow: 1 }}>
              <div className="header">Generation Date</div>{" "}
              <div>
                {gstrTwoBReturnsData?.generation_date
                  ? gstrTwoBReturnsData?.generation_date
                  : "NA"}
              </div>
            </div>

            <div style={{ flexGrow: 1 }}>
              <div className="header">GST Number</div>{" "}
              <div>
                {gstrTwoBReturnsData?.gst_number
                  ? gstrTwoBReturnsData?.gst_number
                  : "NA"}
              </div>
            </div>

            <div style={{ flexGrow: 1 }}>
              <div className="header">Return Period</div>{" "}
              <div>
                {gstrTwoBReturnsData?.return_period == 0 ||
                gstrTwoBReturnsData?.return_period > 0
                  ? convertToMonth(
                      +gstrTwoBReturnsData?.return_period?.slice(0, 2)
                    )
                  : "NA"}
              </div>
            </div>

            <div style={{ flexGrow: 1 }}>
              <div className="header">Legal Name</div>{" "}
              <div>{gstDetails?.legalName ? gstDetails?.legalName : "NA"}</div>
            </div>
            <div style={{ flexGrow: 1 }}>
              {" "}
              <div className="header">Trade Name</div>{" "}
              <div>{gstDetails?.tradeName ? gstDetails?.tradeName : "NA"}</div>{" "}
            </div>
            <div style={{ flexGrow: 1 }}>
              {" "}
              <div className="header">Financial Year</div>{" "}
              <div>
                {gstrTwoBReturnsData?.return_period?.slice(2, 6) ? (
                  <span>
                    <span>
                      {+gstrTwoBReturnsData?.return_period?.slice(2, 6) - 1}
                    </span>{" "}
                    -{" "}
                    <span>
                      {gstrTwoBReturnsData?.return_period?.slice(2, 6)}
                    </span>
                  </span>
                ) : (
                  "NA"
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default GstrTwoATwoBHeader;
